






import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component
export default class Play extends Vue {
  async mounted(): Promise<void> {
    const code = this.$route.query.code.toString();
    const _state = this.$route.query.state;

    if (!code) {
      console.error("No code provided");
      location.replace("/?exitCode=11");
      return;
    }

    const success = await this.$store.direct.dispatch.starhub.handlerequestAuthorizationResponse(code);
    if (success) {
      location.replace("/");
    } else {
      location.replace("/?exitCode=11");
    }
  }
}
